export enum LoadingStatusEnum {
    IDLE = 'idle',
    SUCCESS = 'success',
    ERROR = 'error',
    LOADING = 'loading',
}
